<template>
  <div class="mision">
    <router-link
      to="/progreso"
      class="miperfil abs pointer"
      data-aos="fade-right"
      data-aos-delay="200"
    >
      <img
        src="../../../assets/imgs/mision/btn-mi-perfil.png"
        alt="Encauce"
        class="img-fluid w-100"
      />
    </router-link>

    <section class="pantalla mision4_1">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 contentabs">
            <div class="pregunta abs" data-aos="fade-up" data-aos-delay="200">
              <img
                src="../../../assets/imgs/mision/bg-pregunta-trapezoide.png"
                alt="Encauce"
                class="img-fluid w-100"
              />
              <div
                class="pregunta_txt abs"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div class="blanco bold">
                  {{ retos["p" + base].texto }}.
                  <span
                    v-if="retos['p' + base].complemento != ''"
                    class="verdebrillante p0 fpXG"
                    >{{ retos["p" + base].complemento }}</span
                  >
                </div>
                <div
                  class="electrico"
                  v-html="retos['p' + base].instruccion"
                ></div>
              </div>
            </div>

            <div class="quasar abs" data-aos="fade-up" data-aos-delay="200">
              <img
                src="../../../assets/imgs/mision/quasar-verde.png"
                alt="Encauce"
                class="img-fluid"
              />
            </div>

            <div
              @click="avanzar"
              class="btnavanzar abs"
              data-aos="fade-left"
              data-aos-delay="200"
            >
              <img
                src="../../../assets/imgs/mision/bg-flecha-siguiente.png"
                alt="Encauce"
                class="img-fluid"
              />
              <div class="texto electrico d-flex flex-column">
                <span>Presiona la flecha </span>
                <span class="bold">para continuar</span>
              </div>
            </div>

            <div
              @click="toggleOraculo"
              class="oraculo abs"
              data-aos="fade-left"
              data-aos-delay="200"
            >
              <img
                src="../../../assets/imgs/mision/oraculo.png"
                alt="Encauce"
                class="img-fluid w100 btnoraculo"
              />
              <div class="dialogo" :class="{ active: oraculo === true }">
                <img
                  src="../../../assets/imgs/mision/dialogo-oraculo.png"
                  alt="Encauce"
                  class="img-fluid"
                />
                <div class="cerrar blanco bold">x</div>
                <div class="titulo cyan bold">CONTRASEÑAS SEGURAS</div>
                <div class="texto blanco text-center">
                  Las contraseñas son la clave de tu vida digital. Asegúrate de
                  que tengan al menos diez caracteres de extensión y que
                  incluyan letras, números y símbolos para hacerlas más
                  difíciles de descifrar.
                </div>
              </div>
            </div>

            <div class="menu abs" v-if="base === 0">
              <img
                src="../../../assets/imgs/mision/bg-menu.png"
                alt="Encauce"
                class="img-fluid w-100 bgmenu"
              />

              <!---->
              <div
                @click="mostrarBase(1)"
                class="opcion1 abs opcion"
                data-aos="fade"
                data-aos-delay="800"
              >
                <img
                  src="../../../assets/imgs/mision/4_1/opcion-1.png"
                  alt="Encauce"
                  class="img-fluid"
                />
              </div>

              <!---->

              <div
                @click="mostrarBase(3)"
                class="opcion3 abs opcion"
                data-aos="fade"
                data-aos-delay="800"
              >
                <img
                  src="../../../assets/imgs/mision/4_1/opcion-3.png"
                  alt="Encauce"
                  class="img-fluid"
                />
              </div>

              <div
                @click="mostrarBase(2)"
                class="opcion2 abs opcion"
                data-aos="fade"
                data-aos-delay="800"
              >
                <img
                  src="../../../assets/imgs/mision/4_1/opcion-2.png"
                  alt="Encauce"
                  class="img-fluid"
                />
              </div>

              <div
                @click="mostrarBase(4)"
                class="opcion4 abs opcion"
                data-aos="fade"
                data-aos-delay="800"
              >
                <img
                  src="../../../assets/imgs/mision/4_1/opcion-4.png"
                  alt="Encauce"
                  class="img-fluid"
                />
              </div>

              <div
                @click="mostrarBase(5)"
                class="opcion5 abs opcion"
                data-aos="fade"
                data-aos-delay="800"
              >
                <img
                  src="../../../assets/imgs/mision/4_1/opcion-5.png"
                  alt="Encauce"
                  class="img-fluid"
                />
              </div>
            </div>

            <div
              class="slider abs"
              :class="{ active: base > 0 }"
              v-if="base > 0"
            >
              <div class="bgslider">
                <img
                  src="../../../assets/imgs/mision/4_1/bg-menu.png"
                  alt="Encauce"
                  class="img-fluid w-100"
                />
                <img
                  class="base"
                  :src="
                    require('../../../assets/imgs/mision/4/base-' +
                      base +
                      '.png')
                  "
                  alt="base"
                />

                <div class="flechaizq" @click="flechaClick('izq')">
                  <img
                    src="../../../assets/imgs/mision/4/flecha-izq.png"
                    alt="flecha"
                  />
                </div>

                <div class="flechader" @click="flechaClick('der')">
                  <img
                    src="../../../assets/imgs/mision/4/flecha-der.png"
                    alt="flecha"
                  />
                </div>

                <div class="puntos">
                  <div
                    @click="seleccionaPunto(punto.id)"
                    class="punto"
                    v-for="punto of bases['base_' + base].puntos"
                    :key="punto.id"
                  >
                    <img
                      :src="
                        require('../../../assets/imgs/mision/4/punto-' +
                          punto.id +
                          '.png')
                      "
                      alt="punto"
                    />
                  </div>
                </div>

                <div class="botonera">
                  <div
                    class="btnseleccion"
                    @click="seleccionaBase(1)"
                    :class="{ active: base == 1 }"
                  >
                    <div class="blanco fpG bold pr3">Seleccionar base</div>
                    <div class="check">
                      <img
                        class="img-fluid bgcheck"
                        src="../../../assets/imgs/mision/checkbox.png"
                        alt="checkbox"
                      />
                      <img
                        v-if="base_seleccionada == 1"
                        class="img-fluid palomita"
                        src="../../../assets/imgs/mision/check.png"
                        alt="check"
                      />
                    </div>
                  </div>

                  <div
                    class="btnseleccion"
                    @click="seleccionaBase(2)"
                    :class="{ active: base == 2 }"
                  >
                    <div class="blanco fpG bold pr3">Seleccionar base</div>
                    <div class="check">
                      <img
                        class="img-fluid bgcheck"
                        src="../../../assets/imgs/mision/checkbox.png"
                        alt="checkbox"
                      />
                      <img
                        v-if="base_seleccionada == 2"
                        class="img-fluid palomita"
                        src="../../../assets/imgs/mision/check.png"
                        alt="check"
                      />
                    </div>
                  </div>
                  <div
                    class="btnseleccion"
                    @click="seleccionaBase(3)"
                    :class="{ active: base == 3 }"
                  >
                    <div class="blanco fpG bold pr3">Seleccionar base</div>
                    <div class="check">
                      <img
                        class="img-fluid bgcheck"
                        src="../../../assets/imgs/mision/checkbox.png"
                        alt="checkbox"
                      />
                      <img
                        v-if="base_seleccionada == 3"
                        class="img-fluid palomita"
                        src="../../../assets/imgs/mision/check.png"
                        alt="check"
                      />
                    </div>
                  </div>
                  <div
                    class="btnseleccion"
                    @click="seleccionaBase(4)"
                    :class="{ active: base == 4 }"
                  >
                    <div class="blanco fpG bold pr3">Seleccionar base</div>
                    <div class="check">
                      <img
                        class="img-fluid bgcheck"
                        src="../../../assets/imgs/mision/checkbox.png"
                        alt="checkbox"
                      />
                      <img
                        v-if="base_seleccionada == 4"
                        class="img-fluid palomita"
                        src="../../../assets/imgs/mision/check.png"
                        alt="check"
                      />
                    </div>
                  </div>
                  <div
                    class="btnseleccion"
                    @click="seleccionaBase(5)"
                    :class="{ active: base == 5 }"
                  >
                    <div class="blanco fpG bold pr3">Seleccionar base</div>
                    <div class="check">
                      <img
                        class="img-fluid bgcheck"
                        src="../../../assets/imgs/mision/checkbox.png"
                        alt="checkbox"
                      />
                      <img
                        v-if="base_seleccionada == 5"
                        class="img-fluid palomita"
                        src="../../../assets/imgs/mision/check.png"
                        alt="check"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="overlayinfo bggradazulmorado" v-if="displayInfo">
        <div class="bgoverlay" @click="toggleInfo"></div>
        <div class="overlay container">
          <div class="closeoverlay" @click="toggleInfo">
            <img
              class="img-fluid"
              src="../../../assets/imgs/mision/btn-cerrar-overlay.png"
              alt="cerrar"
            />
          </div>
          <div class="contenido row bggradmorado rounded pt5 px5 pb5">
            <div class="col-8 pt5 pb5">
              <div class="bold pb5">
                <div class="fpXXG blanco">
                  {{ titulo_punto }}: {{ titulo_complemento }}
                </div>
              </div>
              <div class="blanco fpG">
                {{ descripcion_punto }}
              </div>
            </div>
            <div
              class="col-4 d-flex justify-content-center align-items-center pt5 pb5"
            >
              <img
                class="img-fluid"
                :src="
                  require('../../../assets/imgs/mision/4/detalle-' +
                    punto_seleccionado +
                    '.png')
                "
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";
import router from "../../../router/index";
import { mapState } from "vuex";

export default {
  components: {
    Footer,
  },
  data() {
    return {
      loginForm: {
        email: "",
        password: "",
      },
      signupForm: {
        nombre: "",
        apellido: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
      },
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
      res: -1,
      oraculo: false,
      resultado: false,
      time: 0,
      mision: 4,
      reto: 1,
      retos: {
        p0: {
          texto:
            "Has concluido tu entrenamiento, es hora de elegir una de las bases interestelares en las que puedes utilizar tus conocimientos.",
          complemento: "",
          instruccion:
            "Toma tu tiempo y da clic en cada una de las bases para explorar sus objetivos, al finalizar elige la base en la que te gustaría colaborar.",
        },
        p1: {
          texto: "BASE PERSONAS",
          complemento: "Tiene como meta mejorar la vida de las personas.",
          instruccion:
            "Toma tu tiempo y da clic en cada una de las bases para explorar sus objetivos, al finalizar elige la base en la que te gustaría colaborar.",
        },
        p2: {
          texto: "BASE PROSPERIDAD",
          complemento:
            "Tiene como meta el desarrollo sostenible de todas las personas incluyendo el progreso económico, social y tecnológico siempre respetando el planeta.",
          instruccion:
            "Toma tu tiempo y da clic en cada una de las bases para explorar sus objetivos, al finalizar elige la base en la que te gustaría colaborar.",
        },
        p3: {
          texto: "BASE PLANETA",
          complemento:
            "Tiene como meta mantener en buenas condiciones el medio ambiente y preservarlo de los impactos actuales y futuros.",
          instruccion:
            "Toma tu tiempo y da clic en cada una de las bases para explorar sus objetivos, al finalizar elige la base en la que te gustaría colaborar.",
        },
        p4: {
          texto: "BASE PAZ",
          complemento:
            "Tiene como meta fomentar las sociedades libres, justas, igualitarias y en paz.",
          instruccion:
            "Toma tu tiempo y da clic en cada una de las bases para explorar sus objetivos, al finalizar elige la base en la que te gustaría colaborar.",
        },
        p5: {
          texto: "BASE ALIANZAS",
          complemento:
            "Tiene como meta las alianzas necesarias para llevar a cabo todos los ODS.",
          instruccion:
            "Toma tu tiempo y da clic en cada una de las bases para explorar sus objetivos, al finalizar elige la base en la que te gustaría colaborar.",
        },
      },
      base: 0,
      base_seleccionada: -1,
      punto_seleccionado: -1,
      titulo_punto: "",
      titulo_complemento: "",
      descripcion_punto: "",
      displayInfo: false,
      bases: {
        base_1: {
          id: 1,
          nombre: "PERSONAS",
          objetivo:
            "Objetivos que se centran en mejorar la vida de las personas.",
          puntos: [
            {
              id: 1,
              titulo: "Fin de la Pobreza",
              titulo_complemento:
                "Erradicar la pobreza mundial en todas sus formas.",
              descripcion: `Actualmente, más de 700 millones de personas, el equivalente al 10% de la población mundial, viven en pobreza extrema, con dificultades para atender sus necesidades básicas como alimentación, salud, educación, acceso al agua, saneamiento y vivienda digna.`,
            },
            {
              id: 2,
              titulo: "Hambre Cero",
              titulo_complemento: "Acabar con el hambre.",
              descripcion: `De acuerdo con el Programa Mundial de Alimentos, a causa de conflictos ocasionados por los seres humanos, el cambio climático y las recesiones económicas, cerca de 135 millones de personas en el mundo padecen hambre severa.`,
            },
            {
              id: 3,
              titulo: "Salud y Bienestar",
              titulo_complemento:
                "Garantizar una vida sana y promover el bienestar para todos en todas las edades.",
              descripcion: `Asegurar una vida sana y promover el bienestar en todas las edades es esencial para el desarrollo sostenible.`,
            },
            {
              id: 4,
              titulo: "Educación de Calidad",
              titulo_complemento:
                "Garantizar una educación inclusiva, equitativa y de calidad y promover oportunidades de aprendizaje durante toda la vida para todos.",
              descripcion: `La educación es clave para salir de la pobreza, ya que permite el incremento de la movilidad socioeconómica. En la última década, se logró la ampliación del acceso a la educación y en las tasas de matriculación en las escuelas de todos lo niveles, especialmente para las niñas, sin embargo, en 2018, cerca de 260 millones de niños aún no tenían acceso a la escuela, una quinta parte de la población mundial de ese rango. Hoy, la mitad de todos los niños y adolescentes de todo el mundo, siguen sin alcanzar los estándares mínimos de competencia en lectura y matemáticas.`,
            },
            {
              id: 5,
              titulo: "Igualdad de Género",
              titulo_complemento:
                "Lograr la igualdad entre los géneros y empoderar a todas las mujeres y las niñas.",
              descripcion: `La igualdad de género no sólo es un derecho humano primordial, es esencial para lograr un mundo pacífico, próspero y sostenible. En las últimas décadas se ha logrado que más niñas tengan acceso a la escuela, se ha aminorado el matrimonio precoz en niñas, hay más mujeres en cargos parlamentarios y posiciones de liderazgo, además de que las leyes se están reformando para fomentar la equidad de género.`,
            },
          ],
        },
        base_2: {
          id: 2,
          nombre: "PROSPERIDAD",
          objetivo:
            "Estos objetivos tienen como meta el desarrollo sostenible de todas las personas incluyendo el progreso económico, social y tecnológico siempre respetando el planeta.",
          puntos: [
          {
              id: 6,
              titulo: "Agua Limpia y Saneamiento",
              titulo_complemento:
                "Garantizar la disponibilidad de agua y su gestión sostenible y el saneamiento para todos.",
              descripcion: `A pesar de que se ha conseguido de manera sustancial ampliar el acceso al agua potable y saneamiento, aún existe miles de millones de personas que carecen de este servicio. En todo el mundo, una de cada tres personas no tiene acceso al agua potable, dos de cada cinco no disponen de una instalación básica para lavarse las manos con agua y jabón, y más de 673 millones de personas aún defecan al aire libre.`,
            },
            {
              id: 7,
              titulo: "Energía Asequible y No Contaminante",
              titulo_complemento:
                "Garantizar el acceso servicios de energía, segura, sostenible y moderna.",
              descripcion: `El acceso a los servicios de energía ha cobrado relevancia en todo el mundo, incrementando el número de personas que los utilizan, generando una mayor consciencia sobre la importancia en la creación de energías limpias y renovables a través de métodos y sistemas que no dañen el medio ambiente y que nos permiten tener un mundo más sano y sin contaminación.`,
            },
            {
              id: 8,
              titulo: "Trabajo Decente y Crecimiento Económico",
              titulo_complemento:
                "Promover el crecimiento económico inclusivo y sostenible, el empleo y el trabajo decente para todos.",
              descripcion: `Un crecimiento económico sostenido para todos  puede impulsar el progreso, crear empleos mejor pagados y mejorar los niveles de vida.`,
            },
            {
              id: 9,
              titulo: "Industria, Innovación e Infraestructura",
              titulo_complemento:
                "Construir infraestructuras que promuevan la industrialización sostenible y fomentar la innovación.",
              descripcion: `La industrialización inclusiva y sostenible, junto con la innovación tecnológica  y la infraestructura, pueden dar rienda suelta a económicas dinámicas y competitivas que generen fuentes de empleo y garanticen los ingresos. El fomento a la inversión y al desarrollo tecnológico facilitan el comercio internacional y permitir el uso eficiente de los recursos.`,
            },
            {
              id: 10,
              titulo: "Reducción de las Desigualdades",
              titulo_complemento:
                "Reducir la desigualdad en y entre los países.",
              descripcion: `Reducir las desigualdades y garantizar que nadie se queda atrás forma parte integral de los Objetivos de Desarrollo Sostenible de la Organización de las Naciones Unidas. La desigualdad en los países es un continuo motivo de preocupación, a pesar de que se han llevado a cabo estrategias para su reducción en términos económicos, sociales, de salud y de derechos humanos, esta lucha continúa y debe ser parte de las agendas, sobre todo en los países menos favorecidos. `,
            },
            
          ],
        },
        base_3: {
          id: 3,
          nombre: "PLANETA",
          objetivo:
            "Objetivos que buscan mantener en buenas condiciones el medio ambiente y preservarlo de los impactos actuales y futuros.",
          puntos: [
            
            {
              id: 11,
              titulo: "Ciudades y Comunidades Sostenibles",
              titulo_complemento:
                "Lograr que las ciudades sean más inclusivas, seguras, fuertes y sostenibles.",
              descripcion: `Desde 2007, más de la mitad de la población mundial ha estado viviendo en ciudades, y se espera que dicha cantidad aumente hasta el 60 % para el año 2030, aunque las ciudades y áreas metropolitanas son de vital importancia para el desarrollo de cualquier país, éstas representan grandes fuentes de contaminación y de uso indiscriminado de recursos, convirtiéndolas en focos de pobreza sin los servicios adecuados de agua, luz, drenaje, transportación y saneamiento.`,
            },
            {
              id: 12,
              titulo: "Producción y Consumo Responsables",
              titulo_complemento:
                "Garantizar modalidades de consumo y producción sostenibles.",
              descripcion: `El consumo y la producción mundiales (fuerzas impulsoras de la economía mundial) dependen del uso del medio ambiente natural y de los recursos, que aún tienen efectos destructivos sobre el planeta.
El avance económico y social en el último siglo, ha ocasionado la degradación del medio ambiente, poniendo en peligro a los sistemas de los que depende nuestro futuro, es decir, nuestra supervivencia.`,
            },
            {
              id: 13,
              titulo: "Acción por el Clima",
              titulo_complemento:
                "Adoptar medidas urgentes para combatir el cambio climático y sus efectos.",
              descripcion: `El 2019 fue el segundo año más caluroso de todos los tiempos y marcó el final de la década más calurosa (2010-2019) que se haya registrado jamás, ocasionando que los niveles de dióxido de carbono (CO2) y de otros gases de efecto invernadero en la atmósfera, registraran niveles récord en ese año. El cambio climático está afectando a todos los países del mundo, alterando las economías nacionales y la vida de las personas. Los sistemas meteorológicos también se han ido modificando, los niveles del mar están subiendo y los fenómenos naturales cada vez son más extremos.`,
            },
            {
              id: 14,
              titulo: "Vida Submarina",
              titulo_complemento:
                "Conservar y utilizar sosteniblemente los océanos, los mares y los recursos marinos.",
              descripcion: `El océano impulsa los sistemas mundiales que hacen de la Tierra un lugar habitable para el ser humano. La lluvia, el agua potable, el clima, los litorales, gran parte de nuestra comida e incluso el oxígeno del aire que respiramos los proporciona y regula el mar, por lo que el cuidado de este recurso es indispensable para la subsistencia y un futuro sostenible. Sin embargo, la contaminación y la acidificación de los océanos, han ocasionado un deterioro constante, afectando el funcionamiento de los ecosistemas y la biodiversidad.`,
            },
            {
              id: 15,
              titulo: "Vida de Ecosistemas Terrestres",
              titulo_complemento:
                "Gestionar sosteniblemente los bosques, luchar contra la desertificación, detener e invertir la degradación de las tierras, detener la pérdida de biodiversidad.",
              descripcion: `En 2016, el Programa de las Naciones Unidas para el Medio Ambiente (PNUMA) mostró su preocupación sobre el incremento a nivel mundial de las epidemias zoonóticas; y destacó que el 75% de todas las enfermedades infecciosas nuevas en humanos son zoonóticas y están estrechamente  relacionadas con la salud de los ecosistemas.`,
            },
          ],
        },
        base_4: {
          id: 4,
          nombre: "PAZ",
          objetivo:
            "Busca fomentar las sociedades libres, justas, igualitarias y en paz.",
          puntos: [
            {
              id: 16,
              titulo: "Paz, Justicia e Instituciones Sólidas",
              titulo_complemento:
                "Promover sociedades justas, pacíficas e inclusivas.",
              descripcion: `Los conflictos, la inseguridad, la debilidad de las instituciones y el acceso limitado a la justicia, continúan representando una grave amenaza para el desarrollo sostenible.`,
            },
          ],
        },
        base_5: {
          id: 5,
          nombre: "ALIANZAS",
          objetivo:
            "Se basa en las alianzas necesarias para llevar a cabo todos los ODS.",
          puntos: [
            {
              id: 17,
              titulo: "Alianzas para Lograr los Objetivos",
              titulo_complemento:
                "Promover sociedades justas, pacíficas e inclusivas.",
              descripcion: `Los Objetivos de Desarrollo Sustentable solo se pueden conseguir con asociaciones mundiales sólidas y de cooperación. Para que un programa de desarrollo se cumpla satisfactoriamente, es necesario establecer asociaciones inclusivas (a nivel mundial, regional, nacional y local) sobre principios y valores, donde las personas y el planeta sean el objetivo central.`,
            },
          ],
        },
      },
    };
  },
  computed: {
    ...mapState(["userProfile", "posts"]),
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
    this.initTimer();
  },
  methods: {
    mostrarBase(num) {
      this.base = num;
    },
    async avanzar() {
      if (this.base_seleccionada === -1) {
        swal.fire(
          "Oops",
          "Selecciona una base antes de continuar...",
          "warning"
        );
        return;
      }

      this.setAvance();
    },
    async setAvance() {
      let data = {
        index_mision: this.mision - 1,
        write: {
          mision: this.mision,
          base_seleccionada: this.base_seleccionada,
        },
        mision_current: this.mision + 1,
      };

      console.log(data);

      await this.$store.dispatch("setAvance", data);
      await this.$store.dispatch("registroMision4", data);

      router.push("/mision-5-intro");
    },
    initTimer() {
      var vm = this;
      setTimeout(function () {
        vm.tick();
      }, 1000);
    },
    tick() {
      if (this.resultado === true) return;

      this.time++;
      var vm = this;
      setTimeout(function () {
        vm.tick();
      }, 1000);
    },
    siguienteMision() {
      this.$router.push("/progreso");
    },
    toggleOraculo() {
      this.oraculo = !this.oraculo;
    },
    toggleInfo() {
      this.displayInfo = !this.displayInfo;
    },
    flechaClick(direccion) {
      if (direccion === "der") {
        this.base++;
        if (this.base == 6) {
          this.base = 1;
        }
      } else {
        this.base--;
        if (this.base == 0) {
          this.base = 5;
        }
      }
    },
    seleccionaPunto(punto) {
      console.log({ seleccionando: punto });
      console.log({ base: this.base });

      this.toggleInfo();
      this.punto_seleccionado = punto;
      let puntos = this.bases["base_" + this.base].puntos;

      puntos.forEach((element) => {
        console.log(punto);
        if (element.id === punto) {
          this.titulo_punto = element.titulo;
          this.titulo_complemento = element.titulo_complemento;
          this.descripcion_punto = element.descripcion;
        }
      });
    },
    seleccionaBase(base) {
      this.base_seleccionada = base;
    },
  },
};
</script>

<style lang="scss" scoped>
.mision {
  .contentabs {
    .oraculo {
      top: 0%;
      width: 34vw;
      right: 0vw;
      position: absolute;
      z-index: 100;
      cursor: pointer;
      .btnoraculo {
        width: 80%;
        margin-left: 20%;
        position: relative;
      }
      .dialogo {
        position: absolute;
        right: 0%;
        top: 0%;
        width: 120%;
        visibility: hidden;
        pointer-events: none;
        &.active {
          visibility: visible;
          pointer-events: initial;
        }
        .cerrar {
          position: absolute;
          top: 3%;
          right: 6%;
        }
        .titulo {
          position: absolute;
          width: 50%;
          margin: 0 10% 0 40%;
          top: 12%;
          height: 20%;
          display: flex;
          align-items: center;
          font-size: 1.5vw;
        }
        .texto {
          position: absolute;
          width: 80%;
          margin: 0 10%;
          top: 40%;
          font-size: 1.4vw;
        }
      }
    }
    .tiempo-score {
      position: absolute;
      bottom: 3vw;
      right: 8vw;
      width: 20vw;
    }
    .btnavanzar {
      color: white;
      top: 12.5%;
      right: 0%;
      width: 25%;
      position: absolute;
      min-height: 5vw;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      user-select: none;
      transition: 0.25s all ease-out;
      z-index: 100;
      cursor: pointer;
      img {
        width: 20vw;
        padding: 0.4vw 0.6vw;
        float: left;
        position: absolute;
        right: 0%;
        top: 50%;
        transform: translateY(-50%);
      }
      .texto {
        position: absolute;
        z-index: 100;
        top: 8%;
        left: 35%;
        min-height: 5vw;
        width: 62%;
        display: flex;
        flex-direction: column;
        align-items: left;
        justify-content: center;
        padding: 0.5vw;
        font-size: 1.1vw;
        span {
          font-size: 1.05vw;
          text-align: left;
        }
      }
      &:hover {
        transform: scale(1.1);
      }
    }
    .menu {
      bottom: -15%;
      left: 0%;
      right: 0%;
      width: 100%;
      position: absolute;
      .bgmenu {
        opacity: 0;
      }
      .opcion {
        cursor: pointer;
      }
    }
    .pregunta {
      top: 0%;
      left: 8%;
      width: 72%;
      position: absolute;
      z-index: 1000;
      .pregunta_txt {
        top: 50%;
        transform: translateY(-50%);
        left: 0%;
        width: 70%;
        margin: 0 0 0 20%;
        position: absolute;
        div {
          font-size: 1.2vw;
        }
      }
    }
    .quasar {
      top: 4.3%;
      left: 13%;
      width: 7%;
      position: absolute;
      animation: float 6s ease-in-out infinite;
      z-index: 100;
    }

    .mensaje {
      position: absolute;
      top: -2vw;
      left: 50%;
      width: 22vw;
      z-index: 1;
      img {
        width: 100%;
      }
      .texto {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        padding: 0.3vw 1vw 0.3vw 2vw;
        display: flex;
        justify-content: center;
        align-items: center;
        div,
        span {
          font-size: 1.4vw;
        }
      }
      &.invertido {
        left: -5vw;
        .texto {
          padding: 0.3vw 1vw 0.3vw 2vw;
        }
      }
    }
    .checkbox {
      top: -50%;
      width: 6%;
      position: absolute;
      cursor: pointer;
      .check {
        position: absolute;
        top: 0%;
        left: 10%;
        width: 100%;
        visibility: hidden;
        pointer-events: none;
        &.active {
          visibility: visible;
        }
      }
    }
    .checkbox1 {
      left: 8.5%;
    }
    .checkbox2 {
      left: 27.5%;
    }
    .checkbox3 {
      left: 46%;
    }
    .checkbox4 {
      left: 65%;
    }
    .checkbox5 {
      left: 83%;
    }

    .slider {
      top: 25%;
      left: 22%;
      display: none;

      .bgslider {
        height: 70vh;
        width: 70vw;
        position: relative;

        > img {
          height: 100%;
        }
        .base {
          position: absolute;
          height: 30vw;
          left: 0%;
          transform: translateX(-50%);

          bottom: -5%;
        }

        .flechaizq,
        .flechader {
          cursor: pointer;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          z-index: 111;
          width: 10vw;
          img {
            width: 100%;
          }
        }

        .flechaizq {
          left: -23%;
        }
        .flechader {
          right: -6%;
        }

        .puntos {
          position: absolute;
          left: 5%;
          top: 52%;
          transform: translateY(-50%);
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;

          height: 90%;
          margin: 2% 20%;
          width: 60%;
          .punto {
            cursor: pointer;
            width: 27.33%;
            margin: 0 1%;
            margin-bottom: 1%;
            
            img {
              width: 100%;
              max-width: 100%;
            }
          }
        }

        @media (min-width: 768px) {
          .puntos {
            margin: 2% 10%;
            width: 80%;
          }
        }

        .botonera {
          position: absolute;
          top: 15%;
          width: 90%;
          margin: 0 0% 0 0;
          margin-top: -8vh;
          text-align: center;
          display: flex;
          justify-content: flex-end;
          .btnseleccion {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            .check {
              position: relative;
              .bgcheck {
                width: 4vw;
              }
              .palomita {
                width: 8vw;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translateX(-50%) translateY(-50%);
              }
            }
            display: none;
            &.active {
              display: flex;
            }
          }
        }
      }

      &.active {
        display: block;
      }
    }
  }
}

.mision4_1 {
  background: url(../../../assets/imgs/mision/4/bg-nivel-4.jpg) no-repeat;
  background-size: cover;
  background-position: bottom center;
  .opcion1 {
    top: -167%;
    left: -1%;
    width: 25%;
    position: absolute;
    .atomo {
      position: absolute;
      top: 0%;
      left: -40%;
      width: 150%;
      z-index: -1;
      animation: float 2s ease-in-out infinite;
    }
  }
  .opcion2 {
    top: -135%;
    left: 13%;
    width: 36%;
    position: absolute;
    .atomo {
      position: absolute;
      top: -25%;
      left: -64.3%;
      width: 240%;
      z-index: -1;
      animation: float 2s ease-in-out infinite;
    }
  }
  .opcion3 {
    top: -191%;
    left: 37.3%;
    width: 25%;
    position: absolute;
    .atomo {
      position: absolute;
      top: -65%;
      left: -40%;
      width: 180%;
      z-index: -1;
      animation: float 2s ease-in-out infinite;
    }
  }
  .opcion4 {
    top: -115%;
    left: 56%;
    width: 24%;
    position: absolute;
    .atomo {
      position: absolute;
      top: -25%;
      left: -45%;
      width: 180%;
      z-index: -1;
      animation: float 2s ease-in-out infinite;
    }
  }
  .opcion5 {
    top: -164%;
    left: 74%;
    width: 24%;
    position: absolute;
    .atomo {
      position: absolute;
      top: -25%;
      left: -45%;
      width: 180%;
      z-index: -1;
      animation: float 2s ease-in-out infinite;
    }
  }
  .nave {
    top: -28%;
    left: 30%;
    width: 41%;
    position: absolute;
    animation: float 4s infinite;
  }

  .overlayinfo {
    position: fixed;
    top: 0px;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 200;
    .bgoverlay {
      position: fixed;
      top: 0px;
      left: 0;
      bottom: 0;
      right: 0;
    }
    .overlay {
      position: relative;
      .closeoverlay {
        z-index: 10000;
        position: absolute;
        top: -5vw;
        right: -5vw;
        cursor: pointer;
        img {
          width: 10vw;
        }
      }
    }
  }
}
</style>